import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../../components/ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../components/ui/alert-dialog';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { Copy, Calendar, Trash2 } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { cn } from '../../lib/utils';

// Dialog for duplicating activity to another day
export const DuplicateDialog = ({
  open,
  onOpenChange,
  item,
  tripDays,
  currentDayIndex,
  selectedDuplicateDay,
  setSelectedDuplicateDay,
  onDuplicate,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Copy className="w-5 h-5 text-blue-500" />
            Duplicar Atividade
          </DialogTitle>
          <DialogDescription>
            Selecione o dia para onde deseja copiar &quot;{item?.title}&quot;
          </DialogDescription>
        </DialogHeader>

        <div>
          <Label className="mb-3 block">Selecione o dia</Label>
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 max-h-48 overflow-y-auto">
            {tripDays?.map((day, index) => {
              const isCurrentDay = index === currentDayIndex;
              const isSelected = selectedDuplicateDay === index;

              return (
                <button
                  key={index}
                  onClick={() => setSelectedDuplicateDay(index)}
                  disabled={isCurrentDay}
                  className={cn(
                    "flex flex-col items-center p-3 rounded-lg text-sm transition-all",
                    isSelected
                      ? "bg-blue-500 text-white ring-2 ring-blue-400"
                      : isCurrentDay
                        ? "bg-slate-800 text-slate-600 cursor-not-allowed"
                        : "bg-slate-700 text-slate-300 hover:bg-slate-600"
                  )}
                >
                  <Calendar className="w-4 h-4 mb-1" />
                  <span className="font-medium">Dia {index + 1}</span>
                  <span className="text-xs opacity-75">
                    {format(day, 'dd/MM', { locale: ptBR })}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button 
            onClick={onDuplicate}
            disabled={selectedDuplicateDay === null}
            className="bg-blue-500 hover:bg-blue-600"
          >
            <Copy className="w-4 h-4 mr-2" />
            Duplicar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

// Alert dialog for delete confirmation with linked payments warning
export const DeleteConfirmDialog = ({
  open,
  onOpenChange,
  item,
  linkedPayments = [],
  onConfirm,
  onCancel,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Trash2 className="w-5 h-5 text-red-500" />
            Excluir atividade
          </AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir <span className="font-semibold text-white">&quot;{item?.title}&quot;</span>?
            Esta ação não pode ser desfeita.
            {linkedPayments.length > 0 && (
              <span className="block mt-3 p-3 bg-yellow-500/20 border border-yellow-500/50 rounded-lg text-yellow-200">
                <strong>Atenção:</strong> {linkedPayments.length} pagamento(s) vinculado(s) a esta atividade também será(ão) excluído(s).
              </span>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            {linkedPayments.length > 0 ? 'Excluir tudo' : 'Excluir'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
